export const processTexts = (data) => {
  let object = {}
  data.forEach(text => {
    object[text.Position] = text.Text
  })

  return object
}